import {initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/aitems/sliceMaker'

const aitemsSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {data}}) => {
            state.products = data.confirmedProductOrders.map((product) => {
                return {
                    ecNvMid: `${product.ecNvMid ?? ''}`,
                }
            })
        })
    },
})

export default aitemsSlice.reducer
